import React, { useRef, useState } from 'react';
import { CheckCircle2, Loader2, UploadCloud, XCircle } from 'lucide-react';
import { ACCEPTED_VIDEO_TYPES, MAX_VIDEO_BYTES } from '../../lib/reelCreatorConfig';

export default function ClipUpload({ clip, mode = 'upload', validation, onUpload, onFilmAgain }) {
  const inputRef = useRef(null);
  const [error, setError] = useState('');
  const choose = (file) => {
    if (!file) return;
    if (!ACCEPTED_VIDEO_TYPES.includes(file.type) || file.size > MAX_VIDEO_BYTES) return setError('Please choose an MP4, MOV, or WebM video smaller than 250 MB.');
    setError('');
    onUpload(file);
  };
  if (mode === 'checking') return <div className="mx-auto max-w-md py-12 text-center" role="status"><Loader2 className="mx-auto animate-spin text-purple-300" size={50} /><h2 className="mt-6 text-3xl font-bold">Checking Your Clip…</h2><p className="mt-3 text-gray-400">This normally takes a moment.</p></div>;
  if (mode === 'accepted') return <div className="mx-auto max-w-md py-12 text-center" role="status"><CheckCircle2 className="mx-auto text-green-400" size={58} /><h2 className="mt-5 text-3xl font-bold">Clip Accepted</h2><p className="mt-3 text-gray-400">Moving to the next step…</p></div>;
  if (mode === 'retake') return (
    <div className="mx-auto max-w-lg py-8 text-center">
      <XCircle className="mx-auto text-amber-300" size={58} />
      <h2 className="mt-5 text-3xl font-bold">Please Film This Again</h2>
      <p className="mt-5 rounded-xl border border-amber-400/30 bg-amber-500/10 p-4 text-lg text-amber-50">{validation.reason}</p>
      <div className="mt-5 rounded-xl border border-gray-800 bg-gray-900 p-5 text-left"><h3 className="text-xs font-bold uppercase tracking-[0.18em] text-purple-300">Do This</h3><p className="mt-2 text-lg text-white">{validation.singleInstruction}</p></div>
      <button onClick={onFilmAgain} className="mt-6 min-h-14 w-full rounded-xl bg-purple-600 px-5 py-3 font-bold hover:bg-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-300">FILM AGAIN</button>
    </div>
  );
  return (
    <div className="mx-auto max-w-xl text-center">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-purple-300">{clip.title}</p>
      <h2 className="mt-2 text-3xl font-bold">Upload This Clip</h2>
      <button onClick={() => inputRef.current?.click()} className="mt-7 flex min-h-48 w-full flex-col items-center justify-center rounded-2xl border-2 border-dashed border-purple-500/50 bg-purple-500/5 p-6 hover:bg-purple-500/10 focus:outline-none focus:ring-2 focus:ring-purple-300">
        <UploadCloud className="text-purple-300" size={40} /><span className="mt-3 text-lg font-bold">UPLOAD VIDEO</span><span className="mt-1 text-xs text-gray-500">Choose the clip you just filmed</span>
      </button>
      <input ref={inputRef} className="sr-only" type="file" accept="video/mp4,video/quicktime,video/webm,.mp4,.mov,.webm" onChange={(event) => choose(event.target.files?.[0])} />
      {error && <p role="alert" className="mt-3 text-sm text-red-300">{error}</p>}
    </div>
  );
}

